module.exports = __webpack_public_path__ + "static/media/cup.ea28b599.svg";